var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.5,
    height: 19,
    viewBox: "0 0 32.5 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-687 -61)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 29.5,
    transform: "translate(688.5 62.5)",
    fill: "none",
    stroke: "#f28f2f",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 29.5,
    transform: "translate(688.5 70.5)",
    fill: "none",
    stroke: "#f28f2f",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 29.5,
    transform: "translate(688.5 78.5)",
    fill: "none",
    stroke: "#f28f2f",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMenu);
export default __webpack_public_path__ + "static/media/btn-menu.a12d95de4ff445862df48fdd8d2a0960.svg";
export { ForwardRef as ReactComponent };